module.exports = __webpack_public_path__ + "img/Orchestra-rafiki_solo.232b3eaa.svg";